import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconTask = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M7.017 9.853h8.779m-8.78 3.794h6.271m-6.27 3.794h2.508m8.78-3.794l-3.132 4.832a.546.546 0 01-.173.158.516.516 0 01-.637-.098l-1.075-1.137M7.016 3.53H3.544c-.41 0-.802.154-1.092.428A1.42 1.42 0 002 4.989V21.04c0 .387.163.758.452 1.032.29.273.682.427 1.092.427h16.98c.409 0 .801-.154 1.09-.427a1.42 1.42 0 00.453-1.032V4.989a1.42 1.42 0 00-.452-1.032 1.59 1.59 0 00-1.092-.428H17.05M16 4.362a.656.656 0 01-.277.313.867.867 0 01-.444.12H8.788a.866.866 0 01-.444-.12.655.655 0 01-.277-.313l-1.011-2.53a.532.532 0 01-.03-.295.579.579 0 01.134-.275.737.737 0 01.27-.193A.883.883 0 017.776 1h8.515c.12 0 .238.023.346.069.107.046.2.112.27.193s.116.176.134.275c.018.099.008.2-.03.295l-1.012 2.53z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconTask.displayName = "IconTask";

export { IconTask };
